var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',_vm._b({},'router-view',{recommendationModalVisible: _vm.recommendationModalVisible, generationState: _vm.generationState},false))}
var staticRenderFns = []

export { render, staticRenderFns }